import { render, staticRenderFns } from "./NotifySpecificUsers.vue?vue&type=template&id=399b8bb4&"
import script from "./NotifySpecificUsers.vue?vue&type=script&lang=js&"
export * from "./NotifySpecificUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports